import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import './UserHeader.css';
import {getLeagueByRating} from "../../utils/rating/getLeagueByRating";
import {getFormattedPrice} from "../../utils/price/getFormattedPrice";
import CrystalsExchangeModal from "../Modals/CrystalsExchangeModal/CrystalsExchangeModal";
import LoginRequiredModal from "../Modals/LoginRequiredModal/LoginRequiredModal";
import {LOGIN_REQUIRED_REASONS} from "../../configs/guestProfile";
import {MENU_SOUND_MANAGER} from "../../scenes/MenuSoundManager";
import {sendButtonClickEvent} from "../../analytics/gameAnalytics";

// pageId — экран, на котором показана шапка (меню, магазин, страница фракции):
// без него все клики по ней сошлись бы в статистике в одну кучу
function UserHeader({className, onGoToCrystals, onDevLogin, onEmailAuthSuccess, pageId = 'UserHeader'}) {
  const auth = useSelector((state) => state.private.auth);
  const league = getLeagueByRating(auth.rating);
  const [showExchangeModal, setShowExchangeModal] = useState(false);
  // Гость (профиля еще нет, показан моковый — см. configs/guestProfile.js):
  // вместо ника ссылка «Вход», а клик по шапке зовет не обмен кристаллов, а
  // саму авторизацию
  const isGuest = Boolean(auth.isGuest);
  const [showLoginModal, setShowLoginModal] = useState(false);
  // Логин владельца действующего премиума — цветом счета нуменов + иконка
  const isPremiumActive = Boolean(auth.premiumExpiresAt)
    && new Date(auth.premiumExpiresAt).getTime() > Date.now();

  return (
    <div className={`main-menu-header ${className}`}>
      <button
        type="button"
        className="main-menu-header-clickable"
        onClick={() => {
          MENU_SOUND_MANAGER.playMenuButtonClick();
          // Своего события у шапки не было вовсе, а для гостя это главная точка
          // входа в авторизацию — считаем клики отдельно от кнопок меню
          sendButtonClickEvent(pageId, 'header', undefined, {isGuest});
          if (isGuest) {
            setShowLoginModal(true);
            return;
          }
          setShowExchangeModal(true)
        }}
        title={isGuest ? 'Войти в игру' : 'Обменять кристаллы на нумены'}
      >
        <span className="main-menu-nickname">
          {isPremiumActive && (
            <img
              className="main-menu-premium-icon"
              src="/img/icons/premium.png"
              alt="Премиум"
              title="Премиум активен"
            />
          )}
          <span
            className={`main-menu-nickname-text ${isGuest ? 'main-menu-nickname-text_login' : ''} ${isPremiumActive ? 'text-coins' : ''}`}
          >
            {isGuest ? 'Вход' : auth.name}
          </span>

          {!isGuest && (
            <img
              className="main-menu-league-icon"
              src={league.iconPath}
              alt={league.name}
              title={league.name}
            />
          )}
        </span>
        <div className="main-menu-balance">
          <div className="main-menu-balance-item">
            <span className="main-menu-balance-value text-coins">{getFormattedPrice(auth.numens)}</span>
            <img
              className="main-menu-balance-icon"
              src="/img/icons/numens.png"
              alt="Нумены"
            />
          </div>
          <div className="main-menu-balance-item">
            <span className="main-menu-balance-value text-crystals">{getFormattedPrice(auth.crystals)}</span>
            <img
              className="main-menu-balance-icon"
              src="/img/icons/crystal.png"
              alt="Кристаллы"
            />
          </div>
        </div>
      </button>

      {showLoginModal && (
        <LoginRequiredModal
          reason={LOGIN_REQUIRED_REASONS.HEADER}
          onClose={() => setShowLoginModal(false)}
          onDevLogin={onDevLogin}
          onEmailAuthSuccess={onEmailAuthSuccess}
        />
      )}

      {showExchangeModal && (
        <CrystalsExchangeModal
          onClose={() => setShowExchangeModal(false)}
          onGoToCrystals={onGoToCrystals}
        />
      )}
    </div>
  );
}

export default UserHeader;
